import React from 'react';
import ItemsView from '../components/ItemsView';

const StickersView = () => <ItemsView type="Sticker" />;

export default StickersView;
